const configSystem = require("../../configApp");
const { logOut } = require("../../helpers/api");
const {
  faLayerGroup,
  faUsers,
  faChartColumn,
  faSliders,
  faGlobe,
  faClockRotateLeft,
  faBan,
  faStore,
  faLaptop,
  faIdCard,
  faRightLeft,
  faArrowRightFromBracket,
} = require("@fortawesome/free-solid-svg-icons");

exports.config = {
  main: [
    { text: "Applications", to: "/applications", icon: faLayerGroup },
    {
      // Interruptor de la fuente de ProDemand (Compania <-> Laptop). SOLO lo ven
      // el dueno y walter (visibilidad por username, no por rol).
      text: "ProDemand Source",
      to: "/prodemand-source",
      icon: faRightLeft,
      users: ["admin@kaizenteks.com", "walter@gmail.com"],
    },
    {
      // Interruptor de AllData V2 (my.alldata.com de siempre <-> DiagMotor/datape).
      // SOLO el dueno y walter (visibilidad por username).
      text: "AllData Source",
      to: "/alldata-source",
      icon: faRightLeft,
      users: ["admin@kaizenteks.com", "walter@gmail.com"],
    },
    {
      text: "User Management",
      to: "/user-management",
      icon: faUsers,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      // Solo quien ve a otros admins: un admin limitado no tiene a quien resumir.
      text: "Admins",
      to: "/admins-summary",
      icon: faChartColumn,
      roles: [configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Applications Settings",
      to: "/applications-settings",
      icon: faSliders,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Domain Management",
      to: "/domain-management",
      icon: faGlobe,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Access History",
      to: "/access-history",
      icon: faClockRotateLeft,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      // SOLO Super Admin. Ningun otro administrador puede dejar fuera a nadie.
      text: "IP Blocking",
      to: "/ip-blocking",
      icon: faBan,
      roles: [configSystem.roles.SUPER_ADMIN],
    },
    { text: "My Devices", to: "/my-devices", icon: faLaptop },
    { text: "My Account", to: "/my-account", icon: faIdCard },
  ],
  bottom: [{ text: "Log Out", action: logOut, icon: faArrowRightFromBracket }],
};
